<template>
  <v-container class="mods" fluid>
    <div class="mods__hero">
      <div class="mods__hero-main">
        <v-btn
          icon
          class="mods__back"
          :to="{ name: 'MassFunction' }"
        >
          <v-icon color="white">mdi-arrow-left</v-icon>
        </v-btn>
        <div class="mods__hero-icon">
          <v-icon large color="white">mdi-upload-multiple</v-icon>
        </div>
        <div>
          <h1 class="mods__title">Загрузка на домофоны</h1>
          <p class="mods__subtitle">
            {{ pageSubtitle }}
          </p>
        </div>
      </div>
      <div class="mods__hero-side">
        <div
          v-if="pageTab === 0 || pageTab === 1"
          class="mods__counter"
          :class="{ 'mods__counter--active': selected.length }"
        >
          <v-icon left small :color="selected.length ? 'white' : 'primary'">mdi-doorbell-video</v-icon>
          <span>{{ selected.length }}</span>
          <span v-if="uploadJobCount > 1" class="ml-1">· {{ uploadJobCount }} задач</span>
        </div>
        <v-chip
          v-if="hasActiveJob"
          small
          label
          color="orange lighten-4"
          text-color="orange darken-3"
          class="ml-2"
        >
          <v-icon left x-small>mdi-progress-upload</v-icon>
          <span v-if="runningJobsCount">Выполняется</span>
          <span v-if="runningJobsCount && queuedJobsCount"> · </span>
          <span v-if="queuedJobsCount">В очереди: {{ queuedJobsCount }}</span>
        </v-chip>
      </div>
    </div>

    <div class="mods__page-tabs-row">
      <v-tabs
        v-model="pageTab"
        background-color="transparent"
        color="primary"
        class="mods__page-tabs"
      >
        <v-tab class="text-none">
          <v-icon left small>mdi-music-note</v-icon>
          Аудио
        </v-tab>
        <v-tab class="text-none">
          <v-icon left small>mdi-image-outline</v-icon>
          Изображение
        </v-tab>
        <v-tab class="text-none">
          <v-icon left small>mdi-shield-check-outline</v-icon>
          Белый список
        </v-tab>
      </v-tabs>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            class="mods__refresh-btn"
            v-bind="attrs"
            v-on="on"
            :loading="refreshLoading"
            aria-label="Обновить список"
            @click="refreshCurrentTab"
          >
            <v-icon color="white">mdi-reload</v-icon>
          </v-btn>
        </template>
        <span>Обновить список</span>
      </v-tooltip>
    </div>

    <mass-open-door-sound-whitelist
      v-if="pageTab === 2"
      ref="whitelist"
      @changed="onWhitelistChanged"
    />

    <template v-else>
    <div class="mods__steps">
      <div class="mods__step">
        <div class="mods__step-num">1</div>
        <div>
          <div class="mods__step-title">Отфильтруйте</div>
          <div class="mods__step-text">ID, адрес, район, МТО, УК</div>
        </div>
      </div>
      <v-icon small color="blue lighten-2" class="mods__step-arrow">mdi-chevron-right</v-icon>
      <div class="mods__step">
        <div class="mods__step-num">2</div>
        <div>
          <div class="mods__step-title">Выберите</div>
          <div class="mods__step-text">Список или карта</div>
        </div>
      </div>
      <v-icon small color="blue lighten-2" class="mods__step-arrow">mdi-chevron-right</v-icon>
      <div class="mods__step">
        <div class="mods__step-num">3</div>
        <div>
          <div class="mods__step-title">Загрузите</div>
          <div class="mods__step-text">Файл → в домофоны</div>
        </div>
      </div>
    </div>

    <v-row>
      <v-col cols="12" md="3" class="pb-2">
        <mass-open-door-sound-filters
          v-model="filters"
          :management-companies="managementCompanies"
          :managements-group="managementsGroup"
          :agents="agents"
          :regions="region"
          :mto-sectors="mtoSectors"
          :mto-sectors-loading="mtoSectorsLoading"
          :models="filterModels"
          @search="onSearch"
          @reset="onSearch"
        />
      </v-col>

      <v-col cols="12" md="9" class="pb-2">
        <div class="mods__workspace">
          <div class="mods__workspace-head">
            <v-tabs
              v-model="tab"
              background-color="transparent"
              color="primary"
              class="mods__tabs"
            >
              <v-tab class="text-none">
                <v-icon left small>mdi-format-list-bulleted</v-icon>
                Список
                <v-chip x-small label class="ml-2" color="blue lighten-5" text-color="primary">
                  {{ totalDoorphones }}
                </v-chip>
              </v-tab>
              <v-tab class="text-none">
                <v-icon left small>mdi-map-outline</v-icon>
                Карта
                <v-chip x-small label class="ml-2" color="blue lighten-5" text-color="primary">
                  {{ mapMarkersCount }}
                </v-chip>
              </v-tab>
            </v-tabs>
          </div>
          <div class="mods__workspace-toolbar">
            <div class="mods__workspace-meta caption">
              <v-icon x-small class="mr-1">mdi-check-circle-outline</v-icon>
              Выбрано: {{ selected.length }}
              <span v-if="tab === 0" class="ml-2">
                (на странице: {{ pageSelected.length }})
              </span>
            </div>
            <div
              v-if="tab === 0"
              class="mods__pager"
              @click.stop
            >
                <span class="mods__pager-label">Строк</span>
                <v-select
                  :value="options.itemsPerPage"
                  :items="pageSizeOptions"
                  dense
                  hide-details
                  outlined
                  class="mods__pager-select"
                  @change="setItemsPerPage"
                />
                <span class="mods__pager-range">{{ pageRangeText }}</span>
                <v-btn
                  icon
                  x-small
                  :disabled="options.page <= 1 || loading"
                  aria-label="Первая страница"
                  @click="setPage(1)"
                >
                  <v-icon small>mdi-page-first</v-icon>
                </v-btn>
                <v-btn
                  icon
                  x-small
                  :disabled="options.page <= 1 || loading"
                  aria-label="Предыдущая страница"
                  @click="setPage(options.page - 1)"
                >
                  <v-icon small>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn
                  icon
                  x-small
                  :disabled="options.page >= pageCount || loading"
                  aria-label="Следующая страница"
                  @click="setPage(options.page + 1)"
                >
                  <v-icon small>mdi-chevron-right</v-icon>
                </v-btn>
                <v-btn
                  icon
                  x-small
                  :disabled="options.page >= pageCount || loading"
                  aria-label="Последняя страница"
                  @click="setPage(pageCount)"
                >
                  <v-icon small>mdi-page-last</v-icon>
                </v-btn>
            </div>
          </div>

          <v-tabs-items v-model="tab" class="mods__tabs-items">
            <v-tab-item>
              <mass-open-door-sound-list
                :items="doorphones"
                :selected.sync="pageSelected"
                :total="totalDoorphones"
                :options.sync="options"
                :loading="loading"
              />
            </v-tab-item>
            <v-tab-item>
              <mass-open-door-sound-map
                v-if="tab === 1"
                :markers="mapDoorphones"
                :selected-ids="selectedIds"
                :regions="region"
                :selected-region-ids="filters.region_id || []"
                :bbox="filters.bbox"
                :loading="mapLoading"
                :load-progress="mapLoadProgress"
                @marker-click="toggleMarker"
                @region-click="onRegionClick"
                @bbox-select="onBboxSelect"
              />
            </v-tab-item>
          </v-tabs-items>
        </div>
      </v-col>
    </v-row>

    <div class="mods__bottom" :class="{ 'mods__bottom--collapsed': !panelOpen }">
      <div class="mods__bottom-bar" @click="panelOpen = !panelOpen">
        <div class="mods__bottom-bar-left">
          <v-icon small color="primary" class="mr-2">mdi-cloud-upload-outline</v-icon>
          <span class="mods__bottom-bar-title">Панель загрузки</span>
          <v-chip
            x-small
            label
            class="ml-2"
            :color="selected.length ? 'primary' : 'blue-grey lighten-4'"
            :text-color="selected.length ? 'white' : 'blue-grey darken-2'"
          >
            {{ selected.length }}
            <template v-if="uploadJobCount > 1"> · {{ uploadJobCount }} задач</template>
          </v-chip>
          <v-chip
            v-if="pageTab === 0 && readySoundsCount"
            x-small
            label
            class="ml-1"
            color="green lighten-4"
            text-color="green darken-3"
          >
            <v-icon left x-small>mdi-music-note</v-icon>
            файлов: {{ readySoundsCount }}
          </v-chip>
          <v-chip
            v-if="pageTab === 1 && lcdImage"
            x-small
            label
            class="ml-1"
            color="green lighten-4"
            text-color="green darken-3"
          >
            <v-icon left x-small>mdi-image-outline</v-icon>
            BMP
          </v-chip>
        </div>
        <v-btn
          icon
          small
          class="mods__bottom-toggle"
          :aria-label="panelOpen ? 'Скрыть панель' : 'Показать панель'"
          @click.stop="panelOpen = !panelOpen"
        >
          <v-icon>{{ panelOpen ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
        </v-btn>
      </div>

      <v-expand-transition>
        <div v-show="panelOpen" class="mods__bottom-body">
          <mass-open-door-sound-upload-panel
            v-if="pageTab === 0"
            :selected="selected"
            :sounds.sync="soundsByModel"
            :schedule.sync="schedule"
            :uploading="uploading"
            :resetting="resetting"
            :selecting-all="selectingAll"
            :selecting-all-from-table="selectingAllFromTable"
            :has-active-job="hasActiveJob"
            :active-jobs="activeJobs"
            :cancelling-jobs="cancellingJobs"
            :max-count="maxCount"
            :total-doorphones="totalDoorphones"
            :job-count="uploadJobCount"
            :selected-all="selectedAllFromTable"
            @select-by-filter="selectAllByFilter"
            @select-from-table="selectAllFromTable"
            @clear="clearSelection"
            @upload="askUpload"
            @reset="askReset"
            @cancel-job="askCancelJob"
          />
          <mass-lcd-image-upload-panel
            v-else
            :selected="selected"
            :image.sync="lcdImage"
            :schedule.sync="schedule"
            :uploading="uploading"
            :resetting="resetting"
            :selecting-all="selectingAll"
            :selecting-all-from-table="selectingAllFromTable"
            :has-active-job="hasActiveJob"
            :active-jobs="activeJobs"
            :cancelling-jobs="cancellingJobs"
            :max-count="maxCount"
            :total-doorphones="totalDoorphones"
            :job-count="uploadJobCount"
            :selected-all="selectedAllFromTable"
            @select-by-filter="selectAllByFilter"
            @select-from-table="selectAllFromTable"
            @clear="clearSelection"
            @upload="askUpload"
            @reset="askReset"
            @cancel-job="askCancelJob"
          />
        </div>
      </v-expand-transition>
    </div>

    <v-dialog v-model="confirmDialog" max-width="480">
      <v-card>
        <v-card-title class="text-h6">{{ confirmTitle }}</v-card-title>
        <v-card-text class="body-1">
          {{ confirmText }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text class="text-none" @click="confirmDialog = false">Отмена</v-btn>
          <v-btn
            :color="confirmKind === 'reset' || confirmKind === 'reset-all' ? 'primary' : 'success'"
            class="text-none"
            :loading="uploading || resetting"
            @click="confirmAction"
          >
            {{ confirmActionLabel }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cancelDialog" max-width="440">
      <v-card>
        <v-card-title class="text-h6">Отменить загрузку?</v-card-title>
        <v-card-text>
          Будет снята только выбранная задача
          <strong v-if="jobToCancel">{{ jobToCancel.mass_upload_id }}</strong>.
          Остальные задания в очереди не затронуты.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text class="text-none" @click="cancelDialog = false">Нет</v-btn>
          <v-btn
            color="error"
            class="text-none"
            :loading="jobToCancel && !!cancellingJobs[jobToCancel.mass_upload_id]"
            @click="confirmCancelJob"
          >
            Отменить задачу
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </template>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import MassOpenDoorSoundFilters from '@/components/massOpenDoorSound/MassOpenDoorSoundFilters.vue';
import MassOpenDoorSoundList from '@/components/massOpenDoorSound/MassOpenDoorSoundList.vue';
import MassOpenDoorSoundMap from '@/components/massOpenDoorSound/MassOpenDoorSoundMap.vue';
import MassOpenDoorSoundUploadPanel from '@/components/massOpenDoorSound/MassOpenDoorSoundUploadPanel.vue';
import MassLcdImageUploadPanel from '@/components/massOpenDoorSound/MassLcdImageUploadPanel.vue';
import MassOpenDoorSoundWhitelist from '@/components/massOpenDoorSound/MassOpenDoorSoundWhitelist.vue';
import { buildSchedulePayload } from '@/components/massFunction/utils/schedulePayload';
import { getOpenDoorSoundModelKey, groupSelectedBySoundModel } from '@/components/massFunction/utils/openDoorSoundModelKey';

const MAX_COUNT = 1000;
const PAGE_SIZE_OPTIONS = [20, 50, 100, 200, 1000];
const MAX_SELECT_PAGES = 50;
const RV3434_MODEL_NAME = 'RV-3434';

function emptyFilters () {
  return {
    id: '',
    address: '',
    management_company_id: null,
    management_group_id: null,
    agent_id: null,
    region_id: [],
    mto_sector_id: [],
    type: null,
    model_id: null,
    physical_status: null,
    bbox: null,
  };
}

function pageTabFromQuery (query) {
  const tab = query && query.tab;
  if (tab === 'image' || tab === '1') return 1;
  if (tab === 'whitelist' || tab === '2') return 2;
  return 0;
}

export default {
  name: 'MassOpenDoorSound',
  components: {
    MassOpenDoorSoundFilters,
    MassOpenDoorSoundList,
    MassOpenDoorSoundMap,
    MassOpenDoorSoundUploadPanel,
    MassLcdImageUploadPanel,
    MassOpenDoorSoundWhitelist,
  },
  data () {
    return {
      maxCount: MAX_COUNT,
      pageTab: pageTabFromQuery(this.$route.query),
      tab: 0,
      filters: emptyFilters(),
      doorphones: [],
      mapDoorphones: [],
      mapLoading: false,
      mapLoadProgress: { loaded: 0, total: 0 },
      mapLoadRequestId: 0,
      mapNeedsReload: true,
      totalDoorphones: 0,
      selectedMap: {},
      pageSelected: [],
      loading: false,
      whitelistRefreshing: false,
      selectingAll: false,
      selectingAllFromTable: false,
      uploading: false,
      resetting: false,
      soundsByModel: {},
      lcdImage: null,
      schedule: {
        useSchedule: false,
        startDate: '',
        endDate: '',
      },
      options: {
        page: 1,
        itemsPerPage: 20,
        sortBy: ['id'],
        sortDesc: [true],
      },
      suppressOptionsWatch: false,
      panelOpen: false,
      suppressSelectionSync: false,
      mtoSectorsLoading: false,
      cancellingJobs: {},
      cancelDialog: false,
      jobToCancel: null,
      selectedAllFromTable: false,
      confirmDialog: false,
      confirmKind: null,
    };
  },
  computed: {
    ...mapGetters({
      managementsGroup: 'GroupManagementCompany/managementsGroup',
      managementCompanies: 'ManagementCompany/managementCompanies',
      agents: 'Agents/agents',
      model: 'DeviceModel/models',
      region: 'Region/regions',
      mtoSectors: 'MtoSector/mtoSectors',
      audioHasActiveJob: 'MassAudioUploadJobs/hasActiveJob',
      audioQueuedJobsCount: 'MassAudioUploadJobs/queuedJobsCount',
      audioRunningJobsCount: 'MassAudioUploadJobs/runningJobsCount',
      audioActiveJobs: 'MassAudioUploadJobs/activeJobs',
      lcdHasActiveJob: 'MassLcdUploadJobs/hasActiveJob',
      lcdQueuedJobsCount: 'MassLcdUploadJobs/queuedJobsCount',
      lcdRunningJobsCount: 'MassLcdUploadJobs/runningJobsCount',
      lcdActiveJobs: 'MassLcdUploadJobs/activeJobs',
    }),
    isImageTab () {
      return this.pageTab === 1;
    },
    hasActiveJob () {
      return this.isImageTab ? this.lcdHasActiveJob : this.audioHasActiveJob;
    },
    queuedJobsCount () {
      return this.isImageTab ? this.lcdQueuedJobsCount : this.audioQueuedJobsCount;
    },
    runningJobsCount () {
      return this.isImageTab ? this.lcdRunningJobsCount : this.audioRunningJobsCount;
    },
    activeJobs () {
      return this.isImageTab ? this.lcdActiveJobs : this.audioActiveJobs;
    },
    pageSubtitle () {
      if (this.pageTab === 2) {
        return 'Домофоны, калитки и доп. входы без рекламы и показаний счётчиков';
      }
      if (this.pageTab === 1) {
        return 'Отберите домофоны моделью RV-3434 фильтрами или на карте, приложите .bmp и запустите фоновую задачу';
      }
      return 'Отберите домофоны фильтрами или на карте, приложите .wav и запустите фоновую задачу';
    },
    selected () {
      return Object.values(this.selectedMap);
    },
    selectedIds () {
      return Object.keys(this.selectedMap).map(Number);
    },
    refreshLoading () {
      if (this.pageTab === 2) return this.whitelistRefreshing;
      return this.loading || (this.tab === 1 && this.mapLoading);
    },
    sortQuery () {
      const by = this.options.sortBy && this.options.sortBy[0];
      if (!by) return '-id';
      const desc = this.options.sortDesc && this.options.sortDesc[0];
      return desc ? `-${by}` : by;
    },
    mapMarkersCount () {
      return (this.mapDoorphones || []).filter(m => m.geo_lat != null && m.geo_lon != null).length;
    },
    readySoundsCount () {
      return Object.values(this.soundsByModel || {}).filter(Boolean).length;
    },
    rv3434ModelId () {
      const found = (this.model || []).find((item) => {
        const name = (item && (item.name || item.model || '')).toString().toUpperCase();
        return name === RV3434_MODEL_NAME || name.replace(/-/g, '') === 'RV3434';
      });
      return found ? found.id : null;
    },
    filterModels () {
      if (this.isImageTab) {
        return (this.model || []).filter((item) => {
          const name = (item && (item.name || item.model || '')).toString().toUpperCase();
          return name === RV3434_MODEL_NAME || name.replace(/-/g, '') === 'RV3434';
        });
      }
      return this.soundSupportedModels;
    },
    apiFilters () {
      const f = {
        exclude_open_door_sound_whitelist: 1,
      };
      if (this.isImageTab) {
        if (this.rv3434ModelId) {
          f.model_id = this.rv3434ModelId;
        }
      } else {
        f.open_door_sound_supported = 1;
      }
      const ids = this.parseIdFilter(this.filters.id);
      if (ids.length) f.id = ids;
      if (this.filters.address) f.address = this.filters.address;
      if (this.filters.management_company_id) f.management_company_id = this.filters.management_company_id;
      if (this.filters.management_group_id) f.management_group_id = this.filters.management_group_id;
      if (this.filters.agent_id) f.agent_id = this.filters.agent_id;
      if (this.filters.region_id && this.filters.region_id.length) f.region_id = this.filters.region_id;
      if (this.filters.mto_sector_id && this.filters.mto_sector_id.length) {
        f.mto_sector_id = this.filters.mto_sector_id;
      }
      if (this.filters.type) f.type = this.filters.type;
      if (!this.isImageTab && this.filters.model_id) f.model_id = this.filters.model_id;
      if (this.filters.physical_status) f.physical_status = this.filters.physical_status;
      if (this.filters.bbox) f.bbox = this.filters.bbox;
      return f;
    },
    soundSupportedModels () {
      return (this.model || []).filter((item) => getOpenDoorSoundModelKey(item.name));
    },
    pageSizeOptions () {
      return PAGE_SIZE_OPTIONS;
    },
    pageCount () {
      const perPage = Number(this.options.itemsPerPage) || 20;
      return Math.max(1, Math.ceil((this.totalDoorphones || 0) / perPage));
    },
    pageRangeText () {
      if (!this.totalDoorphones) return '0 из 0';
      const perPage = Number(this.options.itemsPerPage) || 20;
      const from = (this.options.page - 1) * perPage + 1;
      const to = Math.min(this.totalDoorphones, this.options.page * perPage);
      return `${from}–${to} из ${this.totalDoorphones}`;
    },
    supportedSelected () {
      if (this.isImageTab) {
        return this.selected.filter((item) => {
          const name = (item.model || '').toString().toUpperCase();
          return name === RV3434_MODEL_NAME || name.replace(/-/g, '') === 'RV3434' || item.model_id === this.rv3434ModelId;
        });
      }
      return this.selected.filter((item) => getOpenDoorSoundModelKey(item.model));
    },
    uploadJobCount () {
      const n = this.supportedSelected.length;
      if (!n) return 0;
      return Math.ceil(n / MAX_COUNT);
    },
    confirmTitle () {
      if (this.confirmKind === 'upload-all') return 'Запуск на все домофоны';
      if (this.confirmKind === 'reset-all') {
        return this.isImageTab ? 'Сброс изображения на все домофоны' : 'Сброс на все домофоны';
      }
      if (this.confirmKind === 'reset') {
        return this.isImageTab ? 'Сброс на дефолтную заставку' : 'Сброс на дефолтные аудио';
      }
      return 'Подтверждение';
    },
    confirmText () {
      const total = this.selected.length;
      const jobs = this.uploadJobCount;
      if (this.confirmKind === 'upload-all') {
        return jobs > 1
          ? `Сейчас вы запускаете загрузку на все домофоны (${total} шт.). Будет создано ${jobs} задач по ${MAX_COUNT}. Вы уверены?`
          : `Сейчас вы запускаете загрузку на все домофоны (${total} шт.). Вы уверены?`;
      }
      if (this.confirmKind === 'reset-all') {
        if (this.isImageTab) {
          return jobs > 1
            ? `Сейчас вы сбрасываете LCD на стандартную заставку на всех домофонах (${total} шт.). Будет создано ${jobs} задач по ${MAX_COUNT}. Вы уверены?`
            : `Сейчас вы сбрасываете LCD на стандартную заставку на всех домофонах (${total} шт.). Вы уверены?`;
        }
        return jobs > 1
          ? `Сейчас вы запускаете сброс на все домофоны (${total} шт.). Будет создано ${jobs} задач по ${MAX_COUNT}. Вы уверены?`
          : `Сейчас вы запускаете сброс на все домофоны (${total} шт.). Вы уверены?`;
      }
      if (this.confirmKind === 'reset') {
        if (this.isImageTab) {
          return jobs > 1
            ? `Сбросить изображение на стандартную заставку на ${total} домофонах? Будет создано ${jobs} задач.`
            : `Сбросить изображение на стандартную заставку на ${total} домофонах?`;
        }
        return jobs > 1
          ? `Сбросить аудио на дефолтные, на ${total} домофонах? Будет создано ${jobs} задач.`
          : `Сбросить аудио на дефолтные, на ${total} домофонах?`;
      }
      return '';
    },
    confirmActionLabel () {
      if (this.confirmKind === 'reset' || this.confirmKind === 'reset-all') return 'Сбросить';
      return 'Запустить';
    },
  },
  watch: {
    options: {
      deep: true,
      handler () {
        if (this.suppressOptionsWatch) return;
        this.loadDoorphones();
      },
    },
    pageSelected (rows) {
      if (this.suppressSelectionSync) return;
      const pageIds = new Set(this.doorphones.map(d => d.id));
      const selectedOnPage = new Set((rows || []).map(r => r.id));

      Object.keys(this.selectedMap).forEach((id) => {
        const numId = Number(id);
        if (pageIds.has(numId) && !selectedOnPage.has(numId)) {
          this.$delete(this.selectedMap, id);
          this.selectedAllFromTable = false;
        }
      });

      (rows || []).forEach((row) => {
        if (!this.selectedMap[row.id]) {
          this.$set(this.selectedMap, row.id, row);
        }
      });
    },
    'filters.agent_id' () {
      this.filters.mto_sector_id = [];
      this.loadMtoSectors();
    },
    panelOpen () {
      this.$nextTick(() => {
        window.dispatchEvent(new Event('resize'));
      });
    },
    pageTab (value, prev) {
      if (value === 0 || value === 1) {
        if (prev !== value && (prev === 0 || prev === 1 || prev === 2)) {
          this.clearSelection();
          this.schedule = { useSchedule: false, startDate: '', endDate: '' };
          this.mapNeedsReload = true;
          this.onSearch();
        }
        this.bootstrapJobsForTab();
      }
    },
    rv3434ModelId (id, prev) {
      if (this.isImageTab && id && id !== prev) {
        this.loadDoorphones();
        this.mapNeedsReload = true;
      }
    },
    tab (value) {
      if (value === 1) {
        if (this.mapNeedsReload || !this.mapDoorphones.length) {
          this.loadMapDoorphones();
        }
        this.$nextTick(() => {
          window.dispatchEvent(new Event('resize'));
        });
      }
    },
  },
  created () {
    this.loadDictionaries();
    this.loadDoorphones();
    this.bootstrapJobsForTab();
  },
  beforeDestroy () {
    this.stopPolling();
    this.stopLcdPolling();
  },
  methods: {
    ...mapActions({
      getDoorphones: 'Doorphone/getMfDoorphones',
      loadManagementCompanies: 'ManagementCompany/getManagementCompanies',
      getManagementsGroups: 'GroupManagementCompany/getManagementsGroups',
      getModels: 'DeviceModel/getModels',
      loadRegions: 'Region/getRegions',
      getMtoSectors: 'MtoSector/getMtoSectors',
      uploadOpenDoorSound: 'Doorphone/uploadOpenDoorSound',
      openDoorSoundReset: 'Doorphone/openDoorSoundReset',
      massResetLcdImage: 'Doorphone/massResetLcdImage',
      updateMassLsdSettings: 'Doorphone/updateMassLsdSettings',
      fetchActiveJobs: 'MassAudioUploadJobs/fetchActive',
      startPolling: 'MassAudioUploadJobs/startPolling',
      stopPolling: 'MassAudioUploadJobs/stopPolling',
      cancelJobAction: 'MassAudioUploadJobs/cancelJob',
      fetchLcdActiveJobs: 'MassLcdUploadJobs/fetchActive',
      startLcdPolling: 'MassLcdUploadJobs/startPolling',
      stopLcdPolling: 'MassLcdUploadJobs/stopPolling',
      cancelLcdJobAction: 'MassLcdUploadJobs/cancelJob',
    }),
    bootstrapJobsForTab () {
      if (this.isImageTab) {
        this.stopPolling();
        this.fetchLcdActiveJobs().then(() => {
          if (this.lcdHasActiveJob) {
            this.startLcdPolling();
          }
        });
        return;
      }
      this.stopLcdPolling();
      this.fetchActiveJobs().then(() => {
        if (this.audioHasActiveJob) {
          this.startPolling();
        }
      });
    },
    loadDictionaries () {
      this.loadManagementCompanies({ filters: { with_doorphones: 1 } });
      this.getManagementsGroups({ pagination: 1 });
      this.loadRegions();
      this.getModels();
      this.loadMtoSectors();
    },
    async loadMtoSectors () {
      this.mtoSectorsLoading = true;
      const options = {};
      if (this.filters.agent_id) {
        options.agent_id = this.filters.agent_id;
      }
      try {
        await this.getMtoSectors(options);
      } catch (e) {
        this.$flash_warning('Не удалось загрузить участки МТО');
      } finally {
        this.mtoSectorsLoading = false;
      }
    },
    parseIdFilter (value) {
      return String(value || '')
        .split(/[\s,;]+/)
        .map((part) => Number(part))
        .filter((id) => Number.isInteger(id) && id > 0);
    },
    onWhitelistChanged () {
      this.mapNeedsReload = true;
      this.loadDoorphones();
    },
    refreshCurrentTab () {
      if (this.pageTab === 2) {
        const whitelist = this.$refs.whitelist;
        if (!whitelist || !whitelist.refresh) return;
        this.whitelistRefreshing = true;
        Promise.resolve(whitelist.refresh()).finally(() => {
          this.whitelistRefreshing = false;
        });
        return;
      }
      this.loadDoorphones();
      if (this.tab === 1) {
        this.loadMapDoorphones();
      } else {
        this.mapNeedsReload = true;
      }
    },
    onSearch () {
      this.selectedAllFromTable = false;
      this.$nextTick(() => {
        if (this.options.page !== 1) {
          this.options.page = 1;
        } else {
          this.loadDoorphones();
        }
        if (this.tab === 1) {
          this.loadMapDoorphones();
        } else {
          this.mapNeedsReload = true;
        }
      });
    },
    loadDoorphones () {
      if (this.isImageTab && !this.rv3434ModelId) {
        this.doorphones = [];
        this.totalDoorphones = 0;
        return;
      }
      this.loading = true;
      this.getDoorphones({
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sort: this.sortQuery,
        filters: this.apiFilters,
      })
        .then((response) => {
          this.suppressSelectionSync = true;
          this.doorphones = response.doorphones || [];
          this.totalDoorphones = response.meta?.total || 0;
          this.pageSelected = this.doorphones.filter(d => this.selectedMap[d.id]);
          this.$nextTick(() => {
            this.suppressSelectionSync = false;
          });
        })
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке домофонов');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadMapDoorphones () {
      const requestId = ++this.mapLoadRequestId;
      const pageSize = 1000;
      this.mapLoading = true;
      this.mapNeedsReload = false;
      this.mapLoadProgress = { loaded: 0, total: 0 };

      const loadPage = (page, acc) => this.getDoorphones({
        page,
        limit: pageSize,
        filters: this.apiFilters,
      }).then((response) => {
        if (requestId !== this.mapLoadRequestId) {
          return null;
        }

        const chunk = (response.doorphones || []).map((item) => ({
          id: item.id,
          address: item.address,
          model: item.model,
          geo_lat: item.geo_lat,
          geo_lon: item.geo_lon,
          physical_status: item.physical_status,
          region: item.region,
          management_company: item.management_company,
        }));
        const total = Number(response.meta && response.meta.total);
        const next = acc.concat(chunk);
        const knownTotal = Number.isFinite(total) ? total : next.length;

        this.mapLoadProgress = {
          loaded: next.length,
          total: knownTotal,
        };

        if (!chunk.length || next.length >= knownTotal || page >= 50) {
          this.mapDoorphones = next;
          return next;
        }

        return loadPage(page + 1, next);
      });

      return loadPage(1, [])
        .catch(() => {
          if (requestId === this.mapLoadRequestId) {
            this.mapDoorphones = [];
            this.mapLoadProgress = { loaded: 0, total: 0 };
            this.mapNeedsReload = true;
          }
        })
        .finally(() => {
          if (requestId === this.mapLoadRequestId) {
            this.mapLoading = false;
          }
        });
    },
    syncPageSelected () {
      this.suppressSelectionSync = true;
      this.pageSelected = this.doorphones.filter(d => this.selectedMap[d.id]);
      this.$nextTick(() => {
        this.suppressSelectionSync = false;
      });
    },
    setPage (page) {
      const next = Math.min(this.pageCount, Math.max(1, Number(page) || 1));
      if (this.options.page === next) return;
      this.options.page = next;
    },
    setItemsPerPage (value) {
      const itemsPerPage = Number(value) || 20;
      if (this.options.itemsPerPage === itemsPerPage && this.options.page === 1) return;
      this.options = {
        ...this.options,
        itemsPerPage,
        page: 1,
      };
    },
    chunkItems (items, size) {
      const chunks = [];
      for (let i = 0; i < items.length; i += size) {
        chunks.push(items.slice(i, i + size));
      }
      return chunks;
    },
    toggleMarker (marker) {
      if (this.selectedMap[marker.id]) {
        this.$delete(this.selectedMap, marker.id);
        this.selectedAllFromTable = false;
      } else {
        this.$set(this.selectedMap, marker.id, marker);
      }
      this.syncPageSelected();
    },
    onRegionClick (regionId) {
      const current = [...(this.filters.region_id || [])];
      const idx = current.indexOf(regionId);
      if (idx >= 0) {
        current.splice(idx, 1);
      } else {
        current.push(regionId);
      }
      this.filters.region_id = current;
      this.onSearch();
    },
    onBboxSelect (bbox) {
      this.filters.bbox = bbox;
      this.onSearch();
      if (!bbox) {
        return;
      }
      this.selectDoorphonesByFilter({ openPanel: true });
    },
    clearSelection () {
      this.suppressSelectionSync = true;
      this.selectedMap = {};
      this.pageSelected = [];
      this.soundsByModel = {};
      this.lcdImage = null;
      this.selectedAllFromTable = false;
      this.$nextTick(() => {
        this.suppressSelectionSync = false;
      });
    },
    selectAllByFilter () {
      this.selectDoorphonesByFilter();
    },
    selectAllFromTable () {
      this.selectDoorphonesFromTable();
    },
    selectDoorphonesByFilter ({ openPanel = false } = {}) {
      this.selectingAll = true;
      return this.getDoorphones({
        ids_only: 1,
        filters: this.apiFilters,
      })
        .then((response) => {
          const items = response.doorphones || [];
          if (response.truncated || items.length > this.maxCount) {
            this.$flash_warning(`По фильтру больше ${this.maxCount} домофонов. Выбраны первые ${this.maxCount}.`);
          }
          const next = {};
          items.slice(0, this.maxCount).forEach((item) => {
            next[item.id] = item;
          });
          this.selectedMap = next;
          this.selectedAllFromTable = false;
          this.syncPageSelected();
          if (openPanel) {
            this.panelOpen = true;
          }
          if (!items.length) {
            this.$flash_warning('По текущим фильтрам нет домофонов');
          }
        })
        .catch(() => {
          this.$flash_warning('Не удалось выбрать домофоны по фильтру');
        })
        .finally(() => {
          this.selectingAll = false;
        });
    },
    selectDoorphonesFromTable ({ openPanel = false } = {}) {
      this.selectingAllFromTable = true;
      const pageSize = MAX_COUNT;
      const loadPage = (page, acc) => this.getDoorphones({
        page,
        limit: pageSize,
        filters: this.apiFilters,
      }).then((response) => {
        const chunk = response.doorphones || [];
        const total = Number(response.meta && response.meta.total);
        const next = acc.concat(chunk);
        const knownTotal = Number.isFinite(total) ? total : next.length;

        if (!chunk.length || next.length >= knownTotal || page >= MAX_SELECT_PAGES) {
          return { items: next, total: knownTotal, truncated: next.length < knownTotal };
        }

        return loadPage(page + 1, next);
      });

      return loadPage(1, [])
        .then(({ items, truncated }) => {
          if (truncated) {
            this.$flash_warning(
              `По фильтру слишком много домофонов. Выбраны первые ${items.length}.`,
            );
          }
          const next = {};
          items.forEach((item) => {
            next[item.id] = item;
          });
          this.selectedMap = next;
          this.selectedAllFromTable = items.length > 0 && !truncated;
          this.syncPageSelected();
          if (openPanel) {
            this.panelOpen = true;
          }
          if (!items.length) {
            this.$flash_warning('В таблице нет домофонов по текущим фильтрам');
          } else if (items.length > MAX_COUNT) {
            this.$flash_success(
              `Выбрано ${items.length} домофонов. При запуске будет создано ${Math.ceil(items.length / MAX_COUNT)} задач.`,
            );
          }
        })
        .catch(() => {
          this.$flash_warning('Не удалось выбрать домофоны из таблицы');
        })
        .finally(() => {
          this.selectingAllFromTable = false;
        });
    },
    buildFormData (items) {
      const formData = new FormData();
      const groups = groupSelectedBySoundModel(items);

      groups.forEach((group) => {
        const sound = this.soundsByModel[group.key];
        if (!sound) return;
        group.ids.forEach((id, idx) => {
          formData.append(`${group.key}_doorphones[${idx}]`, id);
        });
        formData.append(`${group.key}_sound`, sound);
      });

      return formData;
    },
    validateUpload () {
      if (this.isImageTab) {
        if (!this.supportedSelected.length) {
          this.$flash_warning('В выборе нет устройств Rubetek RV-3434');
          return { ok: false };
        }
        if (!this.lcdImage) {
          this.$flash_warning('Добавьте BMP-файл изображения');
          return { ok: false };
        }
        const { payload, error } = buildSchedulePayload(this.schedule);
        if (error) {
          this.$flash_warning(error);
          return { ok: false };
        }
        return { ok: true, payload };
      }

      const groups = groupSelectedBySoundModel(this.selected);
      if (!groups.length) {
        this.$flash_warning('В выборе нет устройств Beward / Rubetek с поддержкой аудио');
        return { ok: false };
      }
      const missing = groups.filter((group) => !this.soundsByModel[group.key]);
      if (missing.length) {
        this.$flash_warning(
          `Добавьте аудиофайл для: ${missing.map((g) => g.label).join(', ')}`,
        );
        return { ok: false };
      }
      const { payload, error } = buildSchedulePayload(this.schedule);
      if (error) {
        this.$flash_warning(error);
        return { ok: false };
      }
      return { ok: true, payload };
    },
    askUpload () {
      if (!this.validateUpload().ok) return;
      if (this.selectedAllFromTable) {
        this.confirmKind = 'upload-all';
        this.confirmDialog = true;
        return;
      }
      this.runUpload();
    },
    askReset () {
      if (!this.selected.length) return;
      if (this.isImageTab && !this.supportedSelected.length) {
        this.$flash_warning('В выборе нет домофонов Rubetek RV-3434');
        return;
      }
      this.confirmKind = this.selectedAllFromTable ? 'reset-all' : 'reset';
      this.confirmDialog = true;
    },
    confirmAction () {
      const kind = this.confirmKind;
      this.confirmDialog = false;
      this.confirmKind = null;
      if (kind === 'upload-all') {
        this.runUpload();
        return;
      }
      if (kind === 'reset' || kind === 'reset-all') {
        if (this.isImageTab) {
          this.runLcdReset();
          return;
        }
        this.runReset();
      }
    },
    async runUpload () {
      const check = this.validateUpload();
      if (!check.ok) return;

      if (this.isImageTab) {
        await this.runLcdUpload(check.payload);
        return;
      }

      const items = this.supportedSelected;
      if (!items.length) return;

      const chunks = this.chunkItems(items, MAX_COUNT);
      this.uploading = true;
      const createdIds = [];
      try {
        for (let i = 0; i < chunks.length; i += 1) {
          const formData = this.buildFormData(chunks[i]);
          if (check.payload) {
            formData.append('start_date', check.payload.start_date);
            formData.append('end_date', check.payload.end_date);
          }
          const res = await this.uploadOpenDoorSound(formData);
          if (res && res.mass_upload_id) {
            createdIds.push(res.mass_upload_id);
          }
        }
        if (chunks.length > 1) {
          this.$flash_success(
            `Создано задач: ${chunks.length}. Первая начнёт выполняться, остальные встанут в очередь.`,
          );
        } else {
          this.$flash_success(
            `Задача поставлена в фон${createdIds[0] ? ` (${createdIds[0]})` : ''}. Прогресс — в колокольчике.`,
          );
        }
        this.clearSelection();
        this.fetchActiveJobs().then(() => this.startPolling());
      } catch (e) {
        const message = e?.response?.data?.message;
        const done = createdIds.length;
        this.$flash_warning(
          done
            ? `Создано задач: ${done} из ${chunks.length}. ${message || 'Ошибка при запуске следующей загрузки'}`
            : (message || 'Ошибка при запуске загрузки'),
        );
        this.fetchActiveJobs().then(() => this.startPolling());
      } finally {
        this.uploading = false;
      }
    },
    async runLcdUpload (schedulePayload) {
      const items = this.supportedSelected;
      if (!items.length || !this.lcdImage) return;

      const chunks = this.chunkItems(items, MAX_COUNT);
      this.uploading = true;
      const createdIds = [];
      try {
        for (let i = 0; i < chunks.length; i += 1) {
          const formData = new FormData();
          formData.append('welcome_display', 3);
          formData.append('image', this.lcdImage);
          chunks[i].forEach((item, idx) => {
            formData.append(`doorphones[${idx}]`, item.id);
          });
          if (schedulePayload) {
            formData.append('start_date', schedulePayload.start_date);
            formData.append('end_date', schedulePayload.end_date);
          }
          const res = await this.updateMassLsdSettings(formData);
          if (res && res.mass_upload_id) {
            createdIds.push(res.mass_upload_id);
          }
        }
        if (chunks.length > 1) {
          this.$flash_success(
            `Создано задач: ${chunks.length}. Первая начнёт выполняться, остальные встанут в очередь.`,
          );
        } else {
          this.$flash_success(
            `Задача поставлена в фон${createdIds[0] ? ` (${createdIds[0]})` : ''}. Прогресс — в колокольчике.`,
          );
        }
        this.clearSelection();
        this.fetchLcdActiveJobs().then(() => this.startLcdPolling());
      } catch (e) {
        const message = e?.response?.data?.message || e?.response?.data?.error;
        const done = createdIds.length;
        this.$flash_warning(
          done
            ? `Создано задач: ${done} из ${chunks.length}. ${message || 'Ошибка при запуске следующей загрузки'}`
            : (message || 'Ошибка при запуске загрузки изображения'),
        );
        this.fetchLcdActiveJobs().then(() => this.startLcdPolling());
      } finally {
        this.uploading = false;
      }
    },
    async runReset () {
      const items = this.selected.map(d => d.id);
      if (!items.length) return;
      const chunks = this.chunkItems(items, MAX_COUNT);
      this.resetting = true;
      let created = 0;
      try {
        for (let i = 0; i < chunks.length; i += 1) {
          const res = await this.openDoorSoundReset({ doorphones: chunks[i] });
          if (res && res.mass_upload_id) created += 1;
        }
        if (chunks.length > 1) {
          this.$flash_success(
            `Сброс: создано задач ${chunks.length}. Они пойдут очередью.`,
          );
        } else {
          this.$flash_success('Сброс поставлен в фон');
        }
        this.clearSelection();
        this.fetchActiveJobs().then(() => this.startPolling());
      } catch (e) {
        const message = e?.response?.data?.message;
        this.$flash_warning(
          created
            ? `Создано задач сброса: ${created} из ${chunks.length}. ${message || 'Ошибка'}`
            : (message || 'Ошибка при сбросе'),
        );
        this.fetchActiveJobs().then(() => this.startPolling());
      } finally {
        this.resetting = false;
      }
    },
    async runLcdReset () {
      const items = this.supportedSelected.map(d => d.id);
      if (!items.length) {
        this.$flash_warning('В выборе нет домофонов Rubetek RV-3434');
        return;
      }
      const chunks = this.chunkItems(items, MAX_COUNT);
      this.resetting = true;
      let created = 0;
      try {
        for (let i = 0; i < chunks.length; i += 1) {
          const res = await this.massResetLcdImage({ doorphones: chunks[i] });
          if (res && res.status === false) {
            throw Object.assign(new Error(res.message || res.error || 'Ошибка сброса'), {
              response: { data: res },
            });
          }
          if (res && res.mass_upload_id) created += 1;
        }
        if (chunks.length > 1) {
          this.$flash_success(
            `Сброс изображения: создано задач ${chunks.length}. Они пойдут очередью.`,
          );
        } else {
          this.$flash_success('Сброс изображения поставлен в фон');
        }
        this.clearSelection();
        this.fetchLcdActiveJobs().then(() => this.startLcdPolling());
      } catch (e) {
        const message = e?.response?.data?.message || e?.response?.data?.error || e?.message;
        this.$flash_warning(
          created
            ? `Создано задач сброса: ${created} из ${chunks.length}. ${message || 'Ошибка'}`
            : (message || 'Ошибка при сбросе изображения'),
        );
        this.fetchLcdActiveJobs().then(() => this.startLcdPolling());
      } finally {
        this.resetting = false;
      }
    },
    askCancelJob (job) {
      this.jobToCancel = job;
      this.cancelDialog = true;
    },
    confirmCancelJob () {
      const job = this.jobToCancel;
      if (!job || !job.mass_upload_id) return;
      this.$set(this.cancellingJobs, job.mass_upload_id, true);
      const cancel = this.isImageTab
        ? this.cancelLcdJobAction(job.mass_upload_id)
        : this.cancelJobAction(job.mass_upload_id);
      cancel
        .then((response) => {
          const data = response && response.data ? response.data : response;
          if (data && data.status === false) {
            this.$flash_warning(data.message || 'Не удалось отменить задачу');
            return;
          }
          this.$flash_success('Задача снята с очереди');
          this.cancelDialog = false;
          this.jobToCancel = null;
        })
        .catch((e) => {
          const message = e?.response?.data?.message;
          this.$flash_warning(message || 'Не удалось отменить задачу');
        })
        .finally(() => {
          this.$set(this.cancellingJobs, job.mass_upload_id, false);
        });
    },
  },
};
</script>

<style scoped>
.mods {
  padding-bottom: 24px;
  background: linear-gradient(180deg, #f3f7fc 0%, #fafbfd 180px, transparent 320px);
  min-height: 100%;
}
.mods__hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 18px 20px;
  margin-bottom: 14px;
  border-radius: 16px;
  background: linear-gradient(135deg, #0d4092 0%, #1565c0 48%, #1e88e5 100%);
  box-shadow: 0 8px 24px rgba(13, 64, 146, 0.28);
  color: #fff;
}
.mods__hero-main {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}
.mods__back {
  background: rgba(255, 255, 255, 0.14) !important;
}
.mods__hero-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.mods__title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #fff;
}
.mods__subtitle {
  margin: 4px 0 0;
  font-size: 0.84rem;
  color: rgba(255, 255, 255, 0.82);
  max-width: 560px;
}
.mods__hero-side {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.mods__page-tabs-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 10px 14px 0;
}
.mods__page-tabs {
  margin: 0;
  flex: 1;
  min-width: 0;
}
.mods__page-tabs ::v-deep .v-tabs-bar {
  background: transparent !important;
  height: 42px;
}
.mods__page-tabs ::v-deep .v-tab {
  min-width: 0;
  font-weight: 600;
  letter-spacing: 0;
}
.mods__refresh-btn {
  flex: 0 0 auto;
  width: 40px !important;
  height: 40px !important;
  background: #1a6fd4 !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(26, 111, 212, 0.28);
}
.mods__counter {
  display: inline-flex;
  align-items: center;
  padding: 8px 14px;
  border-radius: 999px;
  background: #fff;
  color: #0d4092;
  font-weight: 700;
  font-size: 0.92rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.mods__counter--active {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.35);
}
.mods__steps {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 14px;
  margin-bottom: 14px;
  background: #fff;
  border: 1px solid #e3eaf3;
  border-radius: 12px;
}
.mods__step {
  display: flex;
  align-items: center;
  gap: 10px;
}
.mods__step-num {
  width: 26px;
  height: 26px;
  border-radius: 8px;
  background: #e3f2fd;
  color: #0d4092;
  font-weight: 700;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mods__step-title {
  font-size: 0.84rem;
  font-weight: 650;
  color: #263238;
  line-height: 1.2;
}
.mods__step-text {
  font-size: 0.72rem;
  color: #90a4ae;
}
.mods__step-arrow {
  margin: 0 4px;
}
.mods__workspace {
  position: relative;
  z-index: 1;
  background: #fff;
  border: 1px solid #e3eaf3;
  border-radius: 14px;
  padding: 8px 12px 12px;
  box-shadow: 0 2px 10px rgba(13, 64, 146, 0.04);
  min-height: 560px;
  overflow: hidden;
  isolation: isolate;
}
.mods__workspace-head {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}
.mods__workspace-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  min-height: 40px;
  margin-bottom: 4px;
}
.mods__workspace-meta {
  color: #78909c;
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  white-space: nowrap;
}
.mods__pager {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: auto;
  flex: 0 0 auto;
}
.mods__pager-label {
  font-size: 0.72rem;
  color: #90a4ae;
  margin-right: 4px;
  white-space: nowrap;
}
.mods__pager-select {
  max-width: 88px;
  font-size: 0.8rem;
}
.mods__pager-select ::v-deep .v-input__slot {
  min-height: 28px !important;
}
.mods__pager-select ::v-deep .v-select__selection {
  font-size: 0.8rem;
  margin: 0 !important;
}
.mods__pager-range {
  font-size: 0.75rem;
  color: #546e7a;
  margin: 0 6px 0 8px;
  white-space: nowrap;
}
.mods__tabs-items {
  background: transparent;
  position: relative;
  z-index: 0;
}
.mods__bottom {
  position: sticky;
  bottom: 0;
  z-index: 1200;
  margin-top: 16px;
  background: #fff;
  border: 1px solid #e3eaf3;
  border-radius: 16px 16px 0 0;
  box-shadow: 0 -8px 28px rgba(13, 64, 146, 0.14);
}
.mods__bottom-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  cursor: pointer;
  user-select: none;
  background: linear-gradient(180deg, #f7fbff 0%, #ffffff 100%);
  border-bottom: 1px solid transparent;
}
.mods__bottom:not(.mods__bottom--collapsed) .mods__bottom-bar {
  border-bottom-color: #e8eef5;
}
.mods__bottom-bar-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  min-width: 0;
}
.mods__bottom-bar-title {
  font-weight: 650;
  font-size: 0.92rem;
  color: #0d4092;
}
.mods__bottom-toggle {
  background: #e3f2fd !important;
}
.mods__bottom-body {
  /* panel content */
}
.mods__bottom-body ::v-deep .mods-panel {
  border: none;
  border-radius: 0;
  box-shadow: none;
}
.mods__bottom-body ::v-deep .mods-panel__accent {
  display: none;
}
</style>
